import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';

function WarehouseIn() {
  return (
    <Outlet />
  );
}

export default memo(WarehouseIn);
